import script from "./TranslateButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TranslateButton.vue?vue&type=script&lang=ts&setup=true"

import "./TranslateButton.vue?vue&type=style&index=0&id=d7bedee0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7bedee0"]])

export default __exports__